import { AriaCoreDatapoint } from "owa-analytics-core/lib/datapoints/AriaCoreDatapoint";
import type { AriaDatapointType, DatapointOptions, CustomDataMap, CustomData, UnifiedEvent, INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT, } from "owa-analytics-types";
import type { MailboxInfo } from "owa-client-types";

export class AriaDatapoint extends AriaCoreDatapoint implements AriaDatapointType {
    private piiData?: string;
    unifiedTelemetry?: UnifiedEvent;
    
    constructor(eventName?: string, mailboxInfo?: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT, extraCustomData?: CustomData, options?: DatapointOptions, props?: CustomDataMap) {
        super(eventName, mailboxInfo, extraCustomData, options, props);
        
        if (options?.unifiedTelemetry) {
            this.addUnifiedTelemetryData(options.unifiedTelemetry);
        }
    }
    
    public addPiiData(value: string): void {
        if (!this.piiData) {
            this.piiData = value;
        }
    }
    
    public addUnifiedTelemetryData(event: UnifiedEvent): void {
        this.unifiedTelemetry = event;
    }
    
    public getPiiData(): string | undefined {
        return this.piiData;
    }
}
